import { Flex } from "@chakra-ui/react";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSetRecoilState, useRecoilState } from "recoil";
import { componentState } from "../../atoms/componentState";
import { openConfirmTerms } from "../../atoms/openConfirmTerms";
import { dateForAPI } from "../../constants/dataFormat";
import CardSaldo from "./components/cardSaldo";
import CarouselComponent from "./components/dashboardCarousel";
import SalesListDashboard from "./components/SalesListDashboard";
import SalesSimulator from "./components/salesSimulator";
import Simulator from "./components/simulator";
import TablesComponent from "./components/tablesComponent";
import ModalConfirmationTerms from "./defaultComponents/modalConfirmationTerms";
import { useMediaQuery } from 'react-responsive'

function Dashboard() {
  const setHeaderLocation = useSetRecoilState(componentState);
  const [isOpen, setIsOpen] = useState(false);
  const dataInicio = moment(Date()).startOf("day").format(dateForAPI);
  const dataFim = moment(Date()).endOf("day").format(dateForAPI);

  const setOpenTerms = useSetRecoilState(openConfirmTerms);
  const openTerms = useRecoilState(openConfirmTerms)[0];

  const [dateF, setDateF] = useState(dataFim);
  const [dateI, setDateI] = useState(dataInicio);

  var largura = window.screen.width;

  const isMobile = useMediaQuery({ query: '(max-width: 900px)' })

  useEffect(() => {
    setHeaderLocation("Dashboard");
  }, []);

  return (
    <Flex width="100%" h={"90vh"} overflowY={"scroll"} overflowX={"hidden"}>
      <Flex
        width={"59vw"}
        // bgColor={BLUEMONEDD}
        height={"100%"}
        mt={"0.3%"}
        h={"100%"}
        mx="auto"
        justifyContent={"space-between"}
        alignItems={"center"}
        flexDir={"column"}
      >
        <Flex
          // bgColor={"red"}
          bgColor={"#1C3E92"}
          w={"90%"}
          // minH={"130px"}
          h={"12vh"}
          flexDir={"column"}
          alignItems="center"
          justifyContent="center"
          borderRadius={"15px"}
          // mt={"3%"}
        >
          <CardSaldo />
        </Flex>
        <Flex
          // bgColor={"red"}
          w={"90%"}
          h={"27vh"}
          flexDir={"column"}
          alignItems="center"
        >
          <TablesComponent dateF={dateF} setDateF={setDateF} dateI={dateI} setDateI={setDateI}/>
        </Flex>
        <Flex
          maxW={"98%"}
          w={"100%"}
          h={"42vh"}
          flexDir={"column"}
          alignItems="center"
          // bgColor={"blue"}
        >
          <SalesListDashboard dateF={dateF} setDateF={setDateF} dateI={dateI} setDateI={setDateI}/>
        </Flex>
      </Flex>
      <Flex
        width={"25vw"}
        // bgColor={ORANGEMONEDD}
        height={"100vh"}
        mt={"0.3%"}
        mx="auto"
        flexDir={"column"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Flex
          // bgColor={ORANGEMONEDD}
          w={"100%"}
          h={"55%"}
          // my={"10px"}
          flexDir={"column"}
          alignItems="center"
        >
          <CarouselComponent />
          {/* <Carousel/> */}
          {/* <ControlePainel/> */}
        </Flex>
        <Flex
          // bgColor={"red"}
          w={"100%"}
          h={"45%"}
          alignItems={"flex-end"}
          justifyContent={"center"}
          // px={3}
          mb={isMobile ? "17vw" : "15vh"}
        >
          <Simulator setIsOpen={setIsOpen} />
        </Flex>
      </Flex>

      <SalesSimulator isOpen={isOpen} setIsOpen={setIsOpen} />
      <ModalConfirmationTerms isOpen={openTerms} setIsOpen={setOpenTerms}/>
    </Flex>
  );
}
export default Dashboard;
